import { Injectable } from '@angular/core';
import { MembershipOptionStore } from './membership-option.store';
import { ApiService } from '../../shared/services/core/api.service';
import { MembershipOption } from './models/membership-option.model';
import { tap, mapTo } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MembershipOptionService {
  constructor(private store: MembershipOptionStore, private api: ApiService) {}

  fetchMembershipOptions() {
    return this.api.get<MembershipOption>('membershipoptions').pipe(
      tap(membershipOptions => this.store.set(membershipOptions)),
      mapTo(null)
    );
  }

  fetchRegistrationMembershipOptions() {
    return this.api.get<MembershipOption>('register/membershipoptions').pipe(
      tap(membershipOptions => this.store.set(membershipOptions)),
      mapTo(null)
    );
  }
}
